import React from "react";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import Periods from "../components/period/Periods";
import { ProtectedRoute } from "../helpers/ProtectedRoute";
import CreatePeriod from "../components/period/CreatePeriod";
import EditPeriod from "../components/period/EditPeriod";

const PeriodRoutes = ({ match: { url } }) => (
  <Switch>
    <Route path={`${url}/`} exact component={Periods} />
    <ProtectedRoute path={`${url}/create/:id`} rols={['manager']} component={CreatePeriod} />
    <ProtectedRoute path={`${url}/edit/:id`} rols={['manager']} component={EditPeriod} />
    <Redirect to="/errors/404" />
  </Switch>
);

PeriodRoutes.propTypes = { match: PropTypes.object.isRequired };

export default withRouter(PeriodRoutes);
